import React, { createContext, useCallback, useContext, useState } from 'react';
import { PopupProps } from '../components/Popup';

type State = {
    popup: PopupProps | null;
    showPopup: (popup: PopupProps) => void;
    closePopup: () => void;
};

type Props = {
    children: React.ReactNode;
};

const PopupContext = createContext<State>({} as State);

const PopupProvider: React.FC<Props> = ({ children }) => {
    const [popup, setPopup] = useState<PopupProps | null>(null);

    const showPopup = useCallback((popup: PopupProps) => setPopup(popup), []);

    const closePopup = useCallback(() => setPopup(null), []);

    return (
        <PopupContext.Provider
            value={{
                popup,
                showPopup,
                closePopup
            }}
        >
            {children}
        </PopupContext.Provider>
    );
};

const usePopup = (): State => {
    const context = useContext(PopupContext);

    return context;
}

export { PopupProvider, usePopup };